// Site-wide custom scripts. Loaded in layout/theme.liquid.

var CART_DRAWER_REOPEN_KEY = 'kaslo_reopen_cart_drawer';
var CART_DISCOUNT_ATTEMPT_KEY = 'kaslo_discount_attempt';

document.addEventListener('submit', function (event) {
  var form = event.target.closest('[data-cart-discount-form]');
  if (!form) return;
  event.preventDefault();

  var input = form.querySelector('input[name="discount_code"]');
  var code = input && input.value.trim();
  if (!code) return;

  if (form.hasAttribute('data-reopen-drawer')) {
    sessionStorage.setItem(CART_DRAWER_REOPEN_KEY, '1');
  }
  sessionStorage.setItem(CART_DISCOUNT_ATTEMPT_KEY, code);

  var redirect = encodeURIComponent(window.location.pathname);
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + redirect;
});

if (sessionStorage.getItem(CART_DRAWER_REOPEN_KEY) === '1') {
  sessionStorage.removeItem(CART_DRAWER_REOPEN_KEY);
  customElements.whenDefined('cart-drawer').then(function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open();
  });
}

var attemptedCode = sessionStorage.getItem(CART_DISCOUNT_ATTEMPT_KEY);
if (attemptedCode) {
  sessionStorage.removeItem(CART_DISCOUNT_ATTEMPT_KEY);

  fetch('/cart.js')
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      var wasInvalid = (cart.discount_codes || []).some(function (discount) {
        return discount.code === attemptedCode && discount.applicable === false;
      });

      if (!wasInvalid) return;

      var message = attemptedCode + ' isn\'t a valid discount code';
      document.querySelectorAll('.cart-discount-error').forEach(function (el) {
        var textEl = el.querySelector('.cart-discount-error__text');
        if (textEl) textEl.textContent = message;
        el.hidden = false;
      });
    })
    .catch(function () {});
}
